module.exports = __webpack_public_path__ + "img/r4.6c6345a8.jpg";